<template>
    <div>
        <div class="form-group">
            <label class="col-md-2 control-label">Discovery Method</label>
            <div class="col-md-10" style="padding-left:20px">
                <div class="form-inline">
                    <label><span>Describe in site narrative description</span></label>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'discoveryMethodInstanceList'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <checkBoxPanel :numColumns="4" :lookupList="discoveryMethodList" ref="discoveryMethodCheckboxPanel" :fieldName="'discoveryMethodId'" :name="qaqcFieldId + 'InvestigativeHistoryDiscoveryMethod'"/>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">Work Performed</label>
            <div class="col-md-10" style="padding-left:20px">
                <div class="form-inline">
                    <label><span>As part of this recording only. Describe numbers and dimensions of sampling/excavation units in narrative section</span></label>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'investigativeWorkInstanceList'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <checkBoxPanel :numColumns="4" :lookupList="workTypeList" ref="workTypeCheckboxPanel" :fieldName="'investigativeWorkTypeId'" :name="qaqcFieldId + 'InvestigativeHistoryWorkPerformed'"/>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">Collections</label>
            <div class="col-md-5" style="padding-left:20px">
                <div class="form-inline">
                    <label><span>Were materials collected as part of this recording</span></label>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'materialsCollectedId'" :hasAppend="false"></qaqcFormFieldSelect>
                </div>
                <select class="form-control" v-model="investigativeHistory.materialsCollectedId" v-validate="'required'" aria-required="true">
                    <option disabled :value=null>Select a value</option>
                    <option value=1>Yes</option>
                    <option value=2>No</option>
                    <option value=3>Unknown</option>
                </select>
            </div>
            <div class="col-md-5" style="padding-left:20px" v-show="investigativeHistory.materialsCollectedId == 1">
                <div class="form-inline">
                    <label><span>Repository</span></label>
                </div>
                <select class="form-control" v-model="investigativeHistory.repositoryId">
                    <option  disabled value="">Select a value</option>
                    <option value=1>U.W. Archaeological Repository</option>
                    <option value=2>Western Wyoming College</option>
                    <option value=3>Other</option>
                </select>
                <div  style="padding-top:10px" v-show="investigativeHistory.repositoryId == 3">
                    <input type="text" class="form-control" placeholder="Other Repository" v-model="investigativeHistory.otherRepository"/>
                </div>
            </div>
        </div>
        <div v-if="!(qaqcEnabled || formDisabled)" class="form-group">
            <div class="col-md-2">
                <button class="btn btn-primary pull-right" v-on:click="saveInvestigativeHistory">Save</button>
            </div>
        </div>
        <qaqcFormFieldFooter v-if="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto" :qaqcSelection="qaqcSelection" :sectionName="'investigativeHistory'" :completeSection="completeSection"></qaqcFormFieldFooter>
        <div v-show="isDebug">
            {{investigativeHistory}}
        </div>
    </div>
</template>

<script>
import loggingService from '../../services/util/loggingService'
import investigativeHistoryService from '../../services/siteForm/investigativeHistoryService'
import loader from '../Loader.vue'
import checkBoxPanel from '../CheckBoxPanel.vue'
import qaqcFormFieldSelect from '@/components/SiteForm/QaqcFormFieldSelect.vue'
import qaqcFormFieldFooter from '@/components/SiteForm/QaqcFormFieldFooter.vue'

export default {
    name: 'investigativeHistoryForm',
    components: {
        loader,
        checkBoxPanel,
        qaqcFormFieldSelect,
        qaqcFormFieldFooter
    },
    props: {
        formDisabled: { default: false },
        qaqcEnabled: { default: false },
        qaqcProgressDto: { default: () => {} },
        saveQaqcProgress: { default: null },
        crrId: { default: null }
    },
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            discoveryMethodList: [],
            workTypeList: [],
            investigativeHistory: {}
        }
    },
    computed: {
        qaqcSelection: function () {
            if (this.qaqcProgressDto && this.qaqcProgressDto.qaqcSelections) {
                // // if there's no nationalRegisterStatus qa/qc object, create new instance
                // if (!this.qaqcProgressDto.qaqcSelections.investigativeHistory) {
                //     this.qaqcProgressDto.qaqcSelections.investigativeHistory = qaqcService.qaqcSelections().investigativeHistory
                // }
                return this.qaqcProgressDto.qaqcSelections.investigativeHistory
            } else {
                return {}
            }
        },
        qaqcFieldId: function () {
            return this.qaqcEnabled ? 'qaqc' : ''
        }
    },
    watch: {
        crrId: function (val) {
            this.log('crrId is changed: ' + val)
            this.loadData().then(result => {
                this.loadLookups()
                this.isLoading = false
            })
        }
    },
    mounted () {
        this.isLoading = true
        if (this.crrId) {
            this.loadData().then(result => {
                this.loadLookups()
                this.isLoading = false
            })
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'InvestigativeHistoryForm', message)
        },

        loadDiscoveryMethods () {
            this.log('load discovery methods')
            var searchDto = {investigativeHistoryId: this.investigativeHistory.investigativeHistoryId}
            return investigativeHistoryService.searchDiscoveryMethod(this.$http, searchDto).then(result => {
                this.$refs.discoveryMethodCheckboxPanel.selectedList = result.data.map(x => {
                    return x.discoveryMethodId
                })
                return result
            })
        },
        loadInvestigativeWorks () {
            this.log('load investigative works for investigative History ID ' + this.investigativeHistory.investigativeHistoryId)
            var searchDto = {investigativeHistoryId: this.investigativeHistory.investigativeHistoryId}
            return investigativeHistoryService.searchInvestigativeWork(this.$http, searchDto).then(result => {
                this.log('found investigative works, count: ' + result.data.length)
                this.$refs.workTypeCheckboxPanel.selectedList = result.data.map(x => {
                    return x.investigativeWorkTypeId
                })
                return result
            })
        },
        createNewInstance () {
            this.investigativeHistory = {
                culturalResourceRecordingId: this.crrId,
                materialsCollectedId: null,
                repositoryId: ''
            }
        },
        loadData () {
            var crrId = this.crrId
            this.log('Loading Data for crrId: ' + crrId)
            return investigativeHistoryService.searchInvestigativeHistory(this.$http, {culturalResourceRecordingId: crrId}).then(response => {
                if (response.data.length > 0) {
                    this.log('found one response')
                    this.investigativeHistory = response.data[0]
                    this.log('enrolled:' + this.investigativeHistory.investigativeHistoryId)
                    Promise.all([
                        this.loadDiscoveryMethods(),
                        this.loadInvestigativeWorks()
                    ]).then(response2 => {
                        this.log('done loading others')
                        return response2
                    })
                } else {
                    this.log('creating new instance')
                    return this.createNewInstance()
                }
            })
        },
        loadLookups () {
            this.discoveryMethodList = investigativeHistoryService.getDiscoveryMethodList()
            this.workTypeList = investigativeHistoryService.getInvestigativeWorkTypeList()
        },
        saveInvestigativeHistory () {
            // set the component checkbox lists
            var investigativeHistoryId = this.investigativeHistory.investigativeHistoryId
            this.investigativeHistory.discoveryMethodInstanceList = this.$refs.discoveryMethodCheckboxPanel.selectedList.map(methodId => {
                return {
                    discoveryMethodId: methodId,
                    investigativeHistoryId: investigativeHistoryId
                }
            })
            this.investigativeHistory.investigativeWorkInstanceList = this.$refs.workTypeCheckboxPanel.selectedList.map(workId => {
                return {
                    investigativeWorkTypeId: workId,
                    investigativeHistoryId: investigativeHistoryId
                }
            })
            investigativeHistoryService.putInvestigativeHistory(this.$http, this.investigativeHistory).then(result => {
                this.loadData().then(result2 => {
                    this.log('save complete')
                })
            })
        },
        completeSection (sectionName) {
            // set consolidated qaqcSelections
            this.qaqcSelection.repositoryId = this.qaqcSelection.materialsCollectedId
            this.qaqcSelection.otherRepository = this.qaqcSelection.materialsCollectedId
            // check if all selections have been made
            if (Object.values(this.qaqcSelection).includes(0)) {
                alert('Please complete all QA/QC selections in this section.')
                return
            }
            this.saveInvestigativeHistory()
            this.saveQaqcProgress(sectionName, true)
        }
    }
}
</script>



// WEBPACK FOOTER //
// InvestigativeHistoryForm.vue?55a1aa56